import React from 'react'

import LoginSignupOAuthOnly from '$extensionSrc/components/Dashboard/LoginSignupOAuthOnly'
import Toast from '$extensionSrc/components/Toast'
import { feedbackBugReportFormPath } from '$extensionSrc/consts/urlConsts'

import styles from './LoginSignupOAuthOnlyPage.module.scss'

export default function LoginSignupOAuthOnlyPage({
  tenantName,
  oauthOptions,
  action,
  error,
}: {
  tenantName: string
  oauthOptions: { name: string; url: string }[]
  action: 'login' | 'signup'
  error?: string
}) {
  return (
    <div className={styles.LoginSignupOAuthOnlyPage}>
      {error && <Toast text={error} color="red" noAutoDismiss showCloseIcon />}
      <LoginSignupOAuthOnly
        tenantName={tenantName}
        oauthOptions={oauthOptions}
        action={action}
      />
      <div className={styles.footer}>
        <div className={styles.footerContent}>
          <a href={feedbackBugReportFormPath} className="link2 black">
            Send feedback or get support
          </a>
        </div>
      </div>
    </div>
  )
}
